import type { IEllipsisDropdownItemProps } from "@similarweb/ui-components";
import { StyledDropdownItemWithCheckbox } from "./styles";

type Props = {
    isPrimary?: boolean;
} & IEllipsisDropdownItemProps;

const FilterDropdownItemWithCheckbox = ({ id, ...itemProps }: Props) => {
    return (
        <StyledDropdownItemWithCheckbox
            {...itemProps}
            key={id}
            id={id}
            showCheckBox
        />
    );
};

export default FilterDropdownItemWithCheckbox;
